export const storageKeys = {
  accessToken: 'newbaptist.accessToken',
  refreshToken: 'newbaptist.refreshToken',
  authData: 'newbaptist.authData',
  memberAccount: 'newbaptist.memberAccount',
  profileCompletion: 'newbaptist.profileCompletion',
  registration: 'newbaptist.registration',
  passwordResetEmail: 'newbaptist.passwordResetEmail',
  passwordResetOtpExpiresAt: 'newbaptist.passwordResetOtpExpiresAt',
  postAuthRedirect: 'newbaptist.postAuthRedirect',
  bibleCache: 'baptistone:bible-cache:v1',
  hymnalCache: 'baptistone:hymnal-cache:v1',
  user: 'newbaptist.user',
} as const;
